import {Link} from 'react-router-dom';
import React, { useContext } from 'react';
import {WebContext} from '../webcontext';

export default function OurDJs() {
  const service = useContext(WebContext);

  switch(service.web?.service.template) {
    case 2:
      return (
        <iframe src="https://embed.ultrastream.io/us_PkatpCQRwnmIJxWze" id="us_PkatpCQRwnmIJxWze" width="100%" title="Our DJ's"></iframe>
      )
    case 1:
      return (
        <>
        
          <section className="breadcrumnd-banner">
            <div className="container">
              <div className="breadcrumnd-content text-center">
                <h3 className="text-uppercase fw-500 white-clr mb-xxl-6 mb-xl-5 mb-4">
                  Our DJ's
                </h3>
                <ul className="breadcrumnd d-flex justify-content-center align-items-center gap-xxl-3 gap-2">
                  <li>
                    <Link to={'/'} className="text-uppercase fw-500">Home</Link>
                  </li>
                  <li>
                    <i className="ph ph-caret-right"></i>
                  </li>
                  <li className="text-uppercase">
                    Our DJ's
                  </li>
                </ul>
              </div>
            </div>
          </section>


          <main className="main position-relative overflow-hidden" id="mains">
            <section className="creative-team-section whitebg pt-space pb-space">
              <div className="container">
                <div className="section-title text-center mb-xxl-15 mb-xl-12 mb-lg-10 mb-8"><span className="fs18 fw-500 theme-clr d-block mb-lg-4 mb-3 aos-init aos-animate" data-aos="zoom-in-left" data-aos-duration="1400">{service.web?.service.title}</span>
                  <h3 className="heading black-clr aos-init aos-animate" data-aos="zoom-in-right" data-aos-duration="1700">Meet our DJ's</h3>
                </div>
                <iframe src="https://embed.ultrastream.io/us_PkatpCQRwnmIJxWze" id="us_PkatpCQRwnmIJxWze" width="100%" title="Our DJ's"></iframe>
              </div>
            </section>
          </main>
        </>
      )
    default:
      return (<></>)
  }
}
